<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <div class="card-header pb-0">
            <h6>Inventario</h6>

            <div class="row align-items-end">
              <div class="col-md-4 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar producto..." @input="fetchData(null)" />
              </div>
              <div class="col-md-2 mb-3">
                <label for="semaphoreFilter" class="mb-1">Semáforo</label>
                <select
                  id="semaphoreFilter"
                  v-model="semaphoreFilter"
                  class="form-select"
                  @change="fetchData(null)"
                >
                  <option value="">Todos</option>
                  <option value="bajo">Bajo</option>
                  <option value="medio">Medio</option>
                  <option value="alto">Alto</option>
                </select>
              </div>
              <div class="col-md-6 mb-3 text-end mt-3" v-if="!isOperator">
                
                <input
                  ref="imageInput"
                  type="file"
                  accept="image/jpeg,image/png,image/jpg,image/webp"
                  class="d-none"
                  @change="onInventoryImageSelected"
                />
                <input
                  ref="cameraInput"
                  type="file"
                  accept="image/*"
                  capture="environment"
                  class="d-none"
                  @change="onInventoryImageSelected"
                />
                <input
                  ref="excelSaldosInput"
                  type="file"
                  accept=".xlsx,.xls"
                  class="d-none"
                  @change="onExcelSaldosSelected"
                />
                <button
                  type="button"
                  class="btn btn-sm btn-outline-warning me-2"
                  :disabled="isImportingExcel"
                  @click="$refs.excelSaldosInput.click()"
                  title="Importar saldos desde Excel ContaPyme"
                >
                  <i :class="isImportingExcel ? 'fas fa-sync fa-spin me-1' : 'fas fa-file-import me-1'"></i>
                  Importar saldos
                </button>
                <button
                  v-if="siigoSyncEnabled"
                  type="button"
                  class="btn btn-sm btn-outline-info me-2"
                  @click="syncSiigo"
                  :disabled="isSyncingSiigo"
                >
                  <i :class="isSyncingSiigo ? 'fas fa-sync fa-spin me-1' : 'fas fa-cloud-download-alt me-1'"></i>
                  Sincronizar Siigo
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-success me-2 px-3"
                  :disabled="isExportingExcel"
                  @click="exportExcel"
                >
                  <i :class="isExportingExcel ? 'fas fa-sync fa-spin' : 'fas fa-file-excel'"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger me-2 px-3"
                  :disabled="isExportingPdf"
                  @click="exportPdf"
                >
                  <i :class="isExportingPdf ? 'fas fa-sync fa-spin' : 'fas fa-file-pdf'"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary me-2"
                  :disabled="isResettingQuantities"
                  @click="resetQuantities"
                  title="Actualizar la cantidad de todos los productos a 0"
                >
                  <i :class="isResettingQuantities ? 'fas fa-sync fa-spin me-1' : 'fas fa-eraser me-1'"></i>
                  Poner cantidad en 0
                </button>
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-sm btn-outline-primary me-2"
                  :disabled="isSyncingAllWooCommerce || syncingId !== null || isSyncingAllMiaAgent"
                  @click="syncAllWooCommerce"
                  title="Sincronizar todos los productos con WordPress"
                >
                  <i :class="isSyncingAllWooCommerce ? 'fas fa-sync fa-spin me-1' : 'fab fa-wordpress me-1'"></i>
                  Sincronizar WordPress
                </button>
                <button
                  v-if="!isOperator && miaAgentEnabled"
                  type="button"
                  class="btn btn-sm btn-outline-info me-2"
                  :disabled="isSyncingAllMiaAgent || syncingMiaAgentId !== null || isSyncingAllWooCommerce"
                  @click="syncAllMiaAgent"
                  title="Sincronizar todos los productos con Mia-Agent"
                >
                  <i :class="isSyncingAllMiaAgent ? 'fas fa-sync fa-spin me-1' : 'fas fa-robot me-1'"></i>
                  Sincronizar Mia-Agent
                </button>
                <router-link :to="{ name: 'Supplies Create' }" class="btn btn-sm btn-primary"
                  data-toggle="tooltip" data-original-title="Agregar al inventario">
                  <i class="fa fa-plus me-1"></i> Agregar inventario
                </router-link>
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-3" style="width: 72px;">
                      Imagen
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ref</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Siigo
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Stock
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Semáforo
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Estado
                    </th>
                    <th
                      v-for="column in visiblePriceColumns"
                      :key="column.key"
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      {{ column.label }}
                    </th>
                    <th
                      v-if="!isOperator"
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td class="align-middle ps-3">
                      <div
                        class="inventory-thumb-cell"
                        :title="value.image_path ? 'Cambiar imagen' : 'Subir imagen'"
                        @click.stop
                      >
                        <div class="inventory-thumb-wrap">
                          <img
                            v-if="productImageUrl(value)"
                            :src="productImageUrl(value)"
                            :alt="value.name"
                            class="inventory-thumb-img"
                            @error="onProductImageError(value)"
                          />
                          <div v-else class="inventory-thumb-placeholder">
                            <i class="fas fa-box-open"></i>
                          </div>
                          <div
                            v-if="uploadingImageId === value.id"
                            class="inventory-thumb-overlay inventory-thumb-overlay--loading"
                          >
                            <i class="fas fa-spinner fa-spin"></i>
                          </div>
                          <div v-else class="inventory-thumb-overlay">
                            <button
                              v-if="!isOperator"
                              type="button"
                              class="inventory-thumb-btn"
                              title="Tomar foto"
                              @click="openCameraPicker(value)"
                            >
                              <i class="fas fa-camera"></i>
                            </button>
                            <button
                              v-if="!isOperator"
                              type="button"
                              class="inventory-thumb-btn"
                              title="Elegir archivo"
                              @click="openImagePicker(value)"
                            >
                              <i class="fas fa-image"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.ref }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        v-if="value.siigo_id"
                        class="badge badge-sm bg-gradient-info inventory-source-badge"
                        :title="value.siigo_id"
                      >
                        Siigo
                      </span>
                      <span
                        v-else
                        class="badge badge-sm bg-gradient-secondary inventory-source-badge"
                      >
                        Local
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span :title="stockTooltip(value)">
                        {{ displayStock(value) }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-danger': stockForSemaphore(value) <= value.low,
                        'bg-gradient-warning': stockForSemaphore(value) <= value.medium,
                        'bg-gradient-success': stockForSemaphore(value) >= value.medium,
                      }">
                        {{
                          stockForSemaphore(value) >= value.high
                            ? 'Alto'
                            : stockForSemaphore(value) > value.low
                              ? 'Medio'
                              : 'Bajo'
                        }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm"
                        :class="value.status == 1 ? 'bg-gradient-success' : 'bg-gradient-warning'">
                        {{ value.status == 1 ? 'Activo' : 'Inactivo' }}
                      </span>
                    </td>
                    <td
                      v-for="column in visiblePriceColumns"
                      :key="`${value.id}-${column.key}`"
                      class="align-middle text-center text-sm"
                    >
                      <div
                        v-if="isOperator && !column.isCost && operatorProfitMargin > 0"
                        class="inventory-price-stack"
                      >
                        <span class="inventory-price-cell">{{ formatPrice(basePrice(value, column)) }}</span>
                        <span class="inventory-price-cell inventory-price-cell--margin">
                          {{ formatPrice(priceWithMargin(value, column)) }}
                        </span>
                      </div>
                      <span v-else class="inventory-price-cell">{{ formatPrice(basePrice(value, column)) }}</span>
                    </td>
                    <td v-if="!isOperator" class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Supplies Create', params: { data: JSON.stringify(value) }, props: true }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i class="fa fa-pencil-alt"></i>
                      </router-link>

                      <a
                        @click="syncWooCommerce(value)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;"
                        data-toggle="tooltip"
                        data-original-title="Sincronizar con WordPress"
                        :class="{ 'opacity-50 pe-none': syncingId === value.id }"
                      >
                        <i
                          :class="syncingId === value.id ? 'fas fa-sync fa-spin' : 'fab fa-wordpress'"
                        ></i>
                      </a>

                      <a
                        v-if="miaAgentEnabled"
                        @click="syncMiaAgent(value)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;"
                        data-toggle="tooltip"
                        data-original-title="Sincronizar con Mia-Agent"
                        :class="{ 'opacity-50 pe-none': syncingMiaAgentId === value.id }"
                      >
                        <i
                          :class="syncingMiaAgentId === value.id ? 'fas fa-sync fa-spin' : 'fas fa-robot'"
                        ></i>
                      </a>

                      <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td :colspan="tableColspan" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import inventoryService from '@/services/inventory.service';
import posService from '@/services/pos.service';
import { buildInventoryImageUrl } from '@/utils/inventoryImage';

const PRICE_LABELS = {
  price: 'Costo',
  precio1: 'Detal',
  precio2: 'Al mayor',
  precio3: 'Mayorista',
  precio4: 'Precio 4',
  precio5: 'Precio 5',
};

export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
      semaphoreFilter: '',
      syncingId: null,
      isSyncingSiigo: false,
      isExportingPdf: false,
      isExportingExcel: false,
      isImportingExcel: false,
      isResettingQuantities: false,
      isSyncingAllWooCommerce: false,
      isSyncingAllMiaAgent: false,
      syncingMiaAgentId: null,
      uploadTargetId: null,
      uploadingImageId: null,
      imageCacheBust: {},
      currentUser: null,
      operatorProfitMargin: 0,
      operatorPriceLevel: null,
    };
  },
  computed: {
    ...mapGetters('inventory', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    ...mapGetters('settings', ['siigoSyncEnabled', 'miaAgentEnabled']),
    isOperator() {
      return String(this.currentUser?.role) === '3';
    },
    visiblePriceColumns() {
      if (!this.isOperator) {
        return [
          { key: 'price', label: PRICE_LABELS.price, isCost: true },
          { key: 'precio1', label: PRICE_LABELS.precio1 },
          { key: 'precio2', label: PRICE_LABELS.precio2 },
          { key: 'precio3', label: PRICE_LABELS.precio3 },
        ];
      }

      if (this.operatorPriceLevel) {
        const key = `precio${this.operatorPriceLevel}`;
        return [{
          key,
          label: PRICE_LABELS[key] || `Precio ${this.operatorPriceLevel}`,
        }];
      }

      return [
        { key: 'price', label: PRICE_LABELS.price, isCost: true },
        { key: 'precio1', label: PRICE_LABELS.precio1 },
        { key: 'precio2', label: PRICE_LABELS.precio2 },
        { key: 'precio3', label: PRICE_LABELS.precio3 },
      ];
    },
    tableColspan() {
      const baseColumns = 7;
      const actionColumn = this.isOperator ? 0 : 1;
      return baseColumns + this.visiblePriceColumns.length + actionColumn;
    },
    currentPage() {
      return this.$store.state.inventory.currentPage;
    },
    lastPage() {
      return this.$store.state.inventory.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['inventory/links'];
    },
  },
  methods: {
    async loadOperatorSettings() {
      try {
        const stored = JSON.parse(localStorage.getItem('user') || 'null');
        this.currentUser = stored;

        if (!stored || String(stored.role) !== '3') {
          return;
        }

        const res = await posService.getSellerSettings();
        const data = res.data || {};
        this.operatorProfitMargin = Math.max(0, parseFloat(data.profit_margin) || 0);
        const level = data.pos_price_level ? Number(data.pos_price_level) : null;
        this.operatorPriceLevel = level >= 1 && level <= 5 ? level : null;

        this.currentUser = {
          ...stored,
          pos_profit_margin: data.profit_margin ?? stored.pos_profit_margin,
          pos_price_level: data.pos_price_level ?? stored.pos_price_level,
        };
        localStorage.setItem('user', JSON.stringify(this.currentUser));
      } catch (error) {
        console.error('No se pudo cargar configuración del operario:', error);
        const stored = JSON.parse(localStorage.getItem('user') || 'null');
        this.currentUser = stored;
        if (stored && String(stored.role) === '3') {
          this.operatorProfitMargin = Math.max(0, parseFloat(stored.pos_profit_margin) || 0);
          const level = Number(stored.pos_price_level);
          this.operatorPriceLevel = level >= 1 && level <= 5 ? level : null;
        }
      }
    },
    basePrice(item, column) {
      return Number(item?.[column.key]) || 0;
    },
    priceWithMargin(item, column) {
      const raw = this.basePrice(item, column);
      if (column.isCost || this.operatorProfitMargin <= 0) {
        return raw;
      }
      return Math.round(raw * (1 + this.operatorProfitMargin / 100));
    },
    formatPrice(value) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(Number(value) || 0);
    },
    stockForSemaphore(item) {
      return Number(item?.total_available ?? item?.quantity) || 0;
    },
    displayStock(item) {
      const total = this.stockForSemaphore(item);
      return Number.isInteger(total) ? total : total.toFixed(2);
    },
    stockTooltip(item) {
      const productionStock = Number(item?.production_stock) || 0;
      if (productionStock <= 0) {
        return '';
      }
      const inventoryQty = Number(item?.quantity) || 0;
      return `Inventario: ${inventoryQty} + Producción: ${productionStock}`;
    },
    productImageUrl(item) {
      if (!item?.image_path || item._imageFailed) return null;
      const url = buildInventoryImageUrl(item.image_path);
      if (!url) return null;
      const bust = this.imageCacheBust[item.id];
      return bust ? `${url}${url.includes("?") ? "&" : "?"}t=${bust}` : url;
    },
    onProductImageError(item) {
      if (item) item._imageFailed = true;
    },
    openImagePicker(item) {
      if (!item?.id || this.uploadingImageId) return;
      this.uploadTargetId = item.id;
      this.$refs.imageInput?.click();
    },
    openCameraPicker(item) {
      if (!item?.id || this.uploadingImageId) return;
      this.uploadTargetId = item.id;
      this.$refs.cameraInput?.click();
    },
    resetImageInputs() {
      if (this.$refs.imageInput) this.$refs.imageInput.value = "";
      if (this.$refs.cameraInput) this.$refs.cameraInput.value = "";
      this.uploadTargetId = null;
    },
    async onInventoryImageSelected(event) {
      const file = event.target.files?.[0];
      const inventoryId = this.uploadTargetId;
      this.resetImageInputs();

      if (!file || !inventoryId) return;

      this.uploadingImageId = inventoryId;
      try {
        const response = await inventoryService.uploadImage(inventoryId, file);
        const path =
          response.data?.image_path ||
          response.data?.inventory?.image_path ||
          "";

        const row = this.data.find((item) => item.id === inventoryId);
        if (row) {
          if (path) {
            row.image_path = path;
            row._imageFailed = false;
          }
          this.imageCacheBust = {
            ...this.imageCacheBust,
            [inventoryId]: Date.now(),
          };
        }

        this.uploadingImageId = null;
        const itemForSync = row || { id: inventoryId, name: "Producto" };
        await this.syncWooCommerce(itemForSync, true);
      } catch (error) {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.message || "No se pudo subir la imagen.",
        });
      } finally {
        this.uploadingImageId = null;
      }
    },
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1,
      };
      if (this.semaphoreFilter) {
        params.semaphore = this.semaphoreFilter;
      }
      await this.$store.dispatch('inventory/fetchData', params);
    },
    async exportPdf() {
      if (this.isExportingPdf) return;

      this.isExportingPdf = true;
      try {
        const response = await inventoryService.exportPdf({
          search: this.searchQuery || undefined,
          semaphore: this.semaphoreFilter || undefined,
        });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `inventario-${new Date().toISOString().slice(0, 10)}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo generar el PDF.',
        });
      } finally {
        this.isExportingPdf = false;
      }
    },
    async exportExcel() {
      if (this.isExportingExcel) return;

      this.isExportingExcel = true;
      try {
        const response = await inventoryService.exportExcel({
          search: this.searchQuery || undefined,
          semaphore: this.semaphoreFilter || undefined,
        });
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `inventario-${new Date().toISOString().slice(0, 10)}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo generar el Excel.',
        });
      } finally {
        this.isExportingExcel = false;
      }
    },
    async syncSiigo() {
      if (!this.siigoSyncEnabled || this.isSyncingSiigo) return;

      const confirm = await Swal.fire({
        title: "Sincronizar Siigo",
        html: "¿Importar o actualizar productos desde Siigo en el inventario?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sincronizar",
        cancelButtonText: "Cancelar",
      });

      if (!confirm.isConfirmed) return;

      this.isSyncingSiigo = true;
      try {
        const response = await inventoryService.syncSiigo();
        const stats = response.data?.data || {};
        await Swal.fire({
          icon: "success",
          title: "Siigo sincronizado",
          html: `
            <p>${response.data?.message || "Sincronización completada."}</p>
            <ul class="text-start mb-0">
              <li>Creados: <strong>${stats.created ?? 0}</strong></li>
              <li>Actualizados: <strong>${stats.updated ?? 0}</strong></li>
            </ul>
          `,
        });
        this.fetchData();
      } catch (error) {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.message || "No se pudo sincronizar con Siigo",
        });
      } finally {
        this.isSyncingSiigo = false;
      }
    },
    async resetQuantities() {
      if (this.isResettingQuantities) return;

      const confirm = await Swal.fire({
        title: '¿Actualizar cantidades a 0?',
        html: 'Esta acción actualizará la <strong>cantidad</strong> de <strong>todos</strong> los productos del inventario a <strong>0</strong>.<br><small class="text-muted">Esta acción no se puede deshacer.</small>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Sí, actualizar',
        cancelButtonText: 'Cancelar',
      });

      if (!confirm.isConfirmed) return;

      this.isResettingQuantities = true;
      try {
        const response = await inventoryService.resetQuantities();
        await Swal.fire({
          icon: 'success',
          title: 'Cantidades actualizadas',
          text: response.data?.message || 'Se actualizó la cantidad de todos los productos a 0.',
        });
        this.fetchData();
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo actualizar las cantidades.',
        });
      } finally {
        this.isResettingQuantities = false;
      }
    },
    async syncMiaAgent(item, skipConfirm = false, silent = false) {
      if (this.syncingMiaAgentId) return false;

      if (!skipConfirm) {
        const confirm = await Swal.fire({
          title: 'Sincronizar con Mia-Agent',
          html: `¿Enviar <strong>${item.name}</strong> a Mia-Agent?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sincronizar',
          cancelButtonText: 'Cancelar',
        });

        if (!confirm.isConfirmed) return false;
      }

      this.syncingMiaAgentId = item.id;
      try {
        const response = await inventoryService.syncMiaAgent(item.id);
        if (!silent) {
          await Swal.fire({
            icon: 'success',
            title: 'Sincronizado',
            html: (response.data?.message || 'Producto sincronizado con Mia-Agent.'),
          });
        }
        this.fetchData();
        return true;
      } catch (error) {
        if (!silent) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            html: (error?.response?.data?.message || 'No se pudo sincronizar con Mia-Agent'),
          });
        }
        return false;
      } finally {
        this.syncingMiaAgentId = null;
      }
    },
    async syncAllMiaAgent() {
      if (this.isSyncingAllMiaAgent || this.syncingMiaAgentId) return;

      const confirm = await Swal.fire({
        title: 'Sincronizar todos con Mia-Agent',
        html: '¿Enviar <strong>todos los productos</strong> a Mia-Agent uno por uno?<br><small class="text-muted">Esta acción puede tardar varios minutos.</small>',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sincronizar todos',
        cancelButtonText: 'Cancelar',
      });

      if (!confirm.isConfirmed) return;

      this.isSyncingAllMiaAgent = true;
      let success = 0;
      let failed = 0;
      const failedNames = [];

      try {
        const allDataResponse = await this.$store.dispatch('inventory/getAll');
        const allItems = Array.isArray(allDataResponse) ? allDataResponse : (allDataResponse?.data || []);

        for (const item of allItems) {
          const result = await this.syncMiaAgent(item, true, true);
          if (result) {
            success++;
          } else {
            failed++;
            failedNames.push(item.name);
          }
        }

        await Swal.fire({
          icon: failed > 0 ? 'warning' : 'success',
          title: 'Sincronización completada',
          html: `
            <p>Productos sincronizados: <strong>${success}</strong></p>
            ${failed > 0 ? `<p>Productos con error: <strong>${failed}</strong></p>` : ''}
            ${failedNames.length > 0 ? `<ul class="text-start mb-0"><li>${failedNames.slice(0, 10).join('</li><li>')}</li>${failedNames.length > 10 ? `<li class="text-muted">...y ${failedNames.length - 10} más</li>` : ''}</ul>` : ''}
          `,
        });
      } catch (error) {
        console.error('Error al sincronizar todos los productos con Mia-Agent:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo obtener la lista de productos para sincronizar.',
        });
      } finally {
        this.isSyncingAllMiaAgent = false;
        this.fetchData();
      }
    },
    async syncWooCommerce(item, skipConfirm = false, silent = false) {
      if (this.syncingId) return false;

      if (!skipConfirm) {
        const confirm = await Swal.fire({
          title: 'Sincronizar con WordPress',
          html: `¿Enviar <strong>${item.name}</strong> a la tienda WooCommerce?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sincronizar',
          cancelButtonText: 'Cancelar',
        });

        if (!confirm.isConfirmed) return false;
      }

      this.syncingId = item.id;
      try {
        const response = await inventoryService.syncWooCommerce(item.id);
        const data = response.data?.data || {};
        const link = data.permalink
          ? `<br><a href="${data.permalink}" target="_blank" rel="noopener">Ver en la tienda</a>`
          : '';
        if (!silent) {
          await Swal.fire({
            icon: 'success',
            title: skipConfirm ? 'Imagen y WordPress actualizados' : 'Sincronizado',
            html: skipConfirm
              ? `La imagen se guardó y <strong>${item.name}</strong> se sincronizó con WooCommerce.${link}`
              : (response.data?.message || 'Producto sincronizado.') + link,
          });
        }
        this.fetchData();
        return true;
      } catch (error) {
        if (!silent) {
          await Swal.fire({
            icon: skipConfirm ? 'warning' : 'error',
            title: skipConfirm ? 'Imagen guardada' : 'Error',
            html: skipConfirm
              ? `La imagen se subió correctamente, pero no se pudo sincronizar con WordPress.<br>${error?.response?.data?.message || 'Intente sincronizar manualmente.'}`
              : (error?.response?.data?.message || 'No se pudo sincronizar con WordPress'),
          });
        }
        return false;
      } finally {
        this.syncingId = null;
      }
    },
    async syncAllWooCommerce() {
      if (this.isSyncingAllWooCommerce || this.syncingId) return;

      const confirm = await Swal.fire({
        title: 'Sincronizar todos con WordPress',
        html: '¿Enviar <strong>todos los productos</strong> a la tienda WooCommerce uno por uno?<br><small class="text-muted">Esta acción puede tardar varios minutos.</small>',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sincronizar todos',
        cancelButtonText: 'Cancelar',
      });

      if (!confirm.isConfirmed) return;

      this.isSyncingAllWooCommerce = true;
      let success = 0;
      let failed = 0;
      const failedNames = [];

      try {
        const allDataResponse = await this.$store.dispatch('inventory/getAll');
        const allItems = Array.isArray(allDataResponse) ? allDataResponse : (allDataResponse?.data || []);

        for (const item of allItems) {
          const result = await this.syncWooCommerce(item, true, true);
          if (result) {
            success++;
          } else {
            failed++;
            failedNames.push(item.name);
          }
        }

        await Swal.fire({
          icon: failed > 0 ? 'warning' : 'success',
          title: 'Sincronización completada',
          html: `
            <p>Productos sincronizados: <strong>${success}</strong></p>
            ${failed > 0 ? `<p>Productos con error: <strong>${failed}</strong></p>` : ''}
            ${failedNames.length > 0 ? `<ul class="text-start mb-0"><li>${failedNames.slice(0, 10).join('</li><li>')}</li>${failedNames.length > 10 ? `<li class="text-muted">...y ${failedNames.length - 10} más</li>` : ''}</ul>` : ''}
          `,
        });
      } catch (error) {
        console.error('Error al sincronizar todos los productos:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo obtener la lista de productos para sincronizar.',
        });
      } finally {
        this.isSyncingAllWooCommerce = false;
        this.fetchData();
      }
    },
    async onExcelSaldosSelected(event) {
      const file = event.target.files?.[0];
      if (this.$refs.excelSaldosInput) this.$refs.excelSaldosInput.value = '';
      if (!file) return;

      const confirm = await Swal.fire({
        title: 'Importar saldos de inventario',
        html: `¿Actualizar <strong>cantidad</strong> y <strong>costo unitario</strong> de los productos encontrados en <em>${file.name}</em>?<br><small class="text-muted">Se actualizarán sólo los productos cuyo código coincida en el inventario.</small>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Importar',
        cancelButtonText: 'Cancelar',
      });

      if (!confirm.isConfirmed) return;

      this.isImportingExcel = true;
      try {
        const response = await inventoryService.importExcelSaldos(file);
        const data = response.data || {};
        const results = data.results || [];
        const notFound = results.filter(r => r.status === 'not_found');

        let html = `<p>Productos actualizados: <strong>${data.updated ?? 0}</strong></p>`;
        if (notFound.length > 0) {
          html += `<p>No encontrados: <strong>${notFound.length}</strong></p>`;
          const list = notFound.slice(0, 10).map(r => `<li>${r.ref}</li>`).join('');
          html += `<ul class="text-start mb-0">${list}</ul>`;
          if (notFound.length > 10) html += `<p class="text-muted">...y ${notFound.length - 10} más</p>`;
        }

        await Swal.fire({
          icon: 'success',
          title: 'Importación completada',
          html,
        });
        this.fetchData();
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error al importar',
          text: error?.response?.data?.message || 'No se pudo procesar el archivo.',
        });
      } finally {
        this.isImportingExcel = false;
      }
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch('inventory/delete', userId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error('Error al eliminar el registro:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
  },
  mounted() {
    try {
      this.currentUser = JSON.parse(localStorage.getItem('user') || 'null');
    } catch {
      this.currentUser = null;
    }
    this.$store.dispatch('settings/get').catch(() => {});
    this.loadOperatorSettings().finally(() => {
      this.fetchData();
    });
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}

.inventory-thumb-cell {
  width: 56px;
}

.inventory-thumb-wrap {
  position: relative;
  width: 56px;
  height: 56px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dee2e6;
  background: #f8f9fa;
}

.inventory-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.inventory-thumb-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #adb5bd;
  font-size: 1.25rem;
}

.inventory-thumb-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  background: rgba(52, 71, 103, 0.72);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.inventory-thumb-wrap:hover .inventory-thumb-overlay,
.inventory-thumb-wrap:focus-within .inventory-thumb-overlay {
  opacity: 1;
}

.inventory-thumb-overlay--loading {
  opacity: 1;
  background: rgba(255, 255, 255, 0.85);
  color: #82d616;
}

.inventory-thumb-btn {
  border: none;
  background: rgba(255, 255, 255, 0.95);
  color: #344767;
  width: 1.65rem;
  height: 1.65rem;
  border-radius: 50%;
  padding: 0;
  line-height: 1;
  font-size: 0.75rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.inventory-thumb-btn:hover {
  background: #fff;
  color: #82d616;
}

.inventory-source-badge {
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.inventory-price-cell {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  color: #344767;
  white-space: nowrap;
}

.inventory-price-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.15rem;
  line-height: 1.2;
}

.inventory-price-cell--margin {
  font-size: 0.7rem;
  font-weight: 700;
  color: #2dce89;
}
</style>
